// extracted by mini-css-extract-plugin
export default {"authenticationSuccessMessage":"authenticationSuccessMessage_AORaMkj","icon":"icon_IqRiQtp","message":"message_AyWer1s","button":"button_EDcQBDs"};